module.exports = __webpack_public_path__ + "static/media/data.804868c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/SRA/data.png
// module id = 3538
// module chunks = 3